export default {
  setWorks: (state, payload) => {
    state.works = [...state.works,...payload];
  },
  setMeta(state, payload) {
    state.meta = payload;
  },
  increasePage: (state) => {
    state.page++;
  },
  allWorksLoaded: (state, payload) => {
    state.allWorksLoaded = payload;
  },
  resetWorkDetails: (state) => {
    state.work = null;
  },
  noResult: (state, payload) => {
    state.noResult = payload;
  },
  reset: (state, ) => {
    state.page = 1;
    state.works=[];
    state.meta = null;
    state.allWorksLoaded=false;
  },
  setWork: (state, payload) => {
    state.work = payload;
  }
    
};
